<div mat-dialog-title class="grid">
  <div class="column-title">
    <span>{{data.title}}</span>
  </div>
  <div class="column-close changecolorclose">
    <button mat-button [mat-dialog-close]="false">
      <mat-icon class="material-icons-outlined icon-close">close</mat-icon>
    </button>
  </div>
</div>
<div mat-dialog-content>
  <p [innerHTML]="data.content"></p>
</div>
<div mat-dialog-actions style="display: flex; justify-content: flex-end;">
  <button mat-button [mat-dialog-close]="false" class="no-button">{{data.cancelButtonText}}</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial class="yes-button">{{data.acceptButtonText}}</button>
</div>